// extracted by mini-css-extract-plugin
module.exports = {"w1bpzdx4":"w1bpzdx4"};